<h4 class="page-title text-left">
  <i class="fab fa-whatsapp fa-lg" style="color: #25D366;"></i> Configurar Integração com Whatsapp
</h4>

<!-- Card de informações do Trial
<div class="trial-info-card" *ngIf="trialInfo">
  <div class="trial-status">
    <div class="status-indicator" [ngClass]="{'active': trialInfo.ativo, 'expired': !trialInfo.ativo}">
      <i class="fas" [ngClass]="{'fa-clock': trialInfo.ativo, 'fa-exclamation-circle': !trialInfo.ativo}"></i>
    </div>
    <div class="status-text">
      <h6>{{ trialInfo.ativo ? 'Trial Ativo' : 'Trial Expirado' }}</h6>
      <span class="days-left" *ngIf="trialInfo.ativo">{{ trialInfo.diasRestantes }} dias restantes</span>
      <span class="expired-text" *ngIf="!trialInfo.ativo">Ative o serviço para continuar</span>
    </div>
  </div>
  <div class="trial-progress" *ngIf="trialInfo.ativo">
    <div class="progress-bar">
      <div class="progress-fill" [style.width]="trialInfo.percentualRestante + '%'"></div>
    </div>
    <div class="trial-dates">
      <span>Início: {{ trialInfo.dataInicio | date:'dd/MM/yyyy' }}</span>
      <span>Término: {{ trialInfo.dataFim | date:'dd/MM/yyyy' }}</span>
    </div>
  </div>
</div>
-->

<!-- Notificação de Trial Ativado -->
<div *ngIf="trialAtivadoRecentemente" class="trial-success-notification">
  <div class="trial-notification-content">
    <div class="notification-icon">
      <i class="fas fa-check-circle pulse-animation"></i>
    </div>
    <div class="notification-text">
      <h5>Trial Ativado com Sucesso!</h5>
      <p>Parabéns! Seu período de teste gratuito de 30 dias foi iniciado. Aproveite todos os recursos premium do WhatsApp Business API sem custos de plataforma. <strong>Atenção:</strong> Custos da plataforma META podem ser aplicáveis de acordo com o volume de conversas e mensagens enviadas.</p>
      <p class="trial-dates">
        <span><strong>Início:</strong> {{dataInicioTrial | date:'dd/MM/yyyy'}}</span>
        <span><strong>Término:</strong> {{dataFimTrial | date:'dd/MM/yyyy'}}</span>
        <span><strong>Dias restantes:</strong> {{diasRestantesTrial}}</span>
      </p>
    </div>
    <button class="btn-close" (click)="fecharNotificacaoTrial()">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<div class="whatsapp-signup-container">
  <div id="fb-root"></div>

  <ng-container *ngIf="!dadosIntegracao.associado">
    <div class="signup-content">
      <div class="signup-text">
        <h5>Conecte seu WhatsApp Business</h5>
        <p>Aumente o engajamento com seus clientes através da integração com WhatsApp Business</p>

        <div class="benefits-section">
          <div class="benefit-item">
            <i class="fas fa-comments"></i>
            <div>
              <h6>Comunicação Direta</h6>
              <p>Envie mensagens diretamente para seus clientes</p>
            </div>
          </div>
          <div class="benefit-item">
            <i class="fas fa-bell"></i>
            <div>
              <h6>Notificações Automáticas</h6>
              <p>Mantenha seus clientes informados sobre pedidos</p>
            </div>
          </div>
          <div class="benefit-item">
            <i class="fas fa-headset"></i>
            <div>
              <h6>Atendimento Eficiente</h6>
              <p>Melhore o suporte ao cliente com respostas rápidas</p>
            </div>
          </div>
        </div>

        <div class="steps-container">
          <h6>Siga os passos abaixo:</h6>
          <ol class="setup-steps">
            <li>Faça login com sua conta do Facebook</li>
            <li>Selecione sua conta do WhatsApp Business</li>
            <li>Autorize o acesso ao WhatsApp</li>
          </ol>
        </div>

        <div class="alert alert-info" role="alert">
          <i class="fas fa-info-circle"></i>
          Certifique-se de ter uma conta WhatsApp Business configurada antes de prosseguir.
        </div>

        <div *ngIf="fbError" class="alert alert-warning mt-3" role="alert">
          <i class="fas fa-exclamation-triangle"></i>
          Não foi possível carregar o SDK do Facebook. Por favor, verifique se bloqueadores de anúncios estão desativados e tente novamente.
        </div>
      </div>

      <div class="actions-container">
        <button
          class="whatsapp-signup-btn"
          (click)="launchWhatsAppSignup()"
          [disabled]="loading">
          <i class="fab fa-whatsapp" [class.fa-spin]="loading"></i>
          <span>{{ loading ? 'Conectando...' : 'Conectar WhatsApp' }}</span>
        </button>

        <button
          *ngIf="fbError"
          class="btn btn-outline-secondary mt-3"
          (click)="reloadPage()">
          <i class="fas fa-sync-alt"></i>
          Recarregar página
        </button>
      </div>
    </div>
  </ng-container>

  <div *ngIf="dadosIntegracao.associado" class="connected-container">
    <div class="status-banner">
      <div class="status-icon">
        <i class="fas fa-check"></i>
      </div>
      <div class="status-text">
        <h5>WhatsApp Business Conectado</h5>
        <p>Sua conta está integrada e pronta para uso</p>
      </div>
      <div class="status-actions">
        <button
          class="btn btn-outline-light test-connection-btn"
          (click)="testarConexao()"
          [disabled]="loading">
          <i class="fas fa-check-circle" [class.fa-spin]="testando"></i>
          <span>{{ testando ? 'Testando...' : 'Testar Conexão' }}</span>
        </button>

        <button
          class="btn disconnect-btn"
          (click)="desconectar()"
          [disabled]="loading">
          <i class="fas fa-power-off" [class.fa-spin]="loading"></i>
          <span>{{ loading ? 'Desconectando...' : 'Desconectar' }}</span>
        </button>
      </div>
    </div>

    <div class="whatsapp-details-container" *ngIf="telefones.length > 0">
      <div class="details-card" *ngFor="let telefone of telefones">
        <div class="details-header">
          <h6>Detalhes do Número</h6>
          <span class="connection-date">Conectado em: {{ telefone.dataCriacao ? (telefone.dataCriacao | date:'dd/MM/yyyy HH:mm') : 'Data não disponível' }}</span>
        </div>

        <div class="details-content">
          <div class="details-row">
            <div class="detail-item">
              <span class="detail-label">Número</span>
              <span class="detail-value phone-number-container">
                <i class="fab fa-whatsapp"></i>
                <span class="phone-number">{{ telefone.telefone }}</span>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Nome</span>
              <span class="detail-value business-name">{{ telefone.nome }}</span>
            </div>
          </div>

          <div class="details-row">
            <div class="detail-item">
              <span class="detail-label">Status</span>
              <span class="status-badge"
                [class.status-pending]="telefone.status === 'NOT_VERIFIED'"
                [class.status-verified]="telefone.status === 'VERIFIED'">
                <i class="fas"
                  [class.fa-clock]="telefone.status === 'NOT_VERIFIED'"
                  [class.fa-check-circle]="telefone.status === 'VERIFIED'"></i>
                {{telefone.status === 'NOT_VERIFIED' ? 'Pendente' : 'Verificado'}}
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Qualidade</span>
              <span class="quality-badge"
                [class.quality-unknown]="telefone.rating === 'UNKNOWN'"
                [class.quality-green]="telefone.rating === 'GREEN'"
                [class.quality-yellow]="telefone.rating === 'YELLOW'"
                [class.quality-red]="telefone.rating === 'RED'">
                <i class="fas fa-circle"></i>
                {{telefone.rating === 'UNKNOWN' ? 'Indisponível' :
                  telefone.rating === 'GREEN' ? 'Alta' :
                  telefone.rating === 'YELLOW' ? 'Média' : 'Baixa'}}
              </span>
            </div>
          </div>

          <div class="tech-details">
            <div class="tech-detail" title="ID interno do WhatsApp Business">
              <span class="tech-label">ID WhatsApp</span>
              <span class="tech-value">{{ telefone.whatsapp_id }}</span>
            </div>
            <div class="tech-detail" title="ID da conta WhatsApp Business">
              <span class="tech-label">ID WABA</span>
              <span class="tech-value">{{ telefone.waba_id }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Nova seção de estatísticas de conversas -->

</div>

<style>
  .meta-info-banner {
    background-color: #f8f9fa;
    padding: 10px 15px;
    border-left: 4px solid #3b5998;
    border-radius: 4px;
    font-size: 14px;
    color: #555;
  }

  .meta-badge {
    font-size: 14px;
    color: #3b5998;
    vertical-align: super;
    margin-left: 3px;
  }

  .badge-light-blue {
    background-color: #e7f3ff;
    color: #3b5998;
    font-size: 12px;
    padding: 3px 8px;
    margin-top: 5px;
  }

  .badge-container {
    margin: 5px 0;
  }

  .card-note {
    background-color: #f8f9fa;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }

  .no-cost {
    color: #28a745;
    font-weight: 500;
  }
</style>

  <h5 class="section-title text-left">
    <i class="fas fa-chart-bar"></i> ESTATÍSTICAS DE CONVERSAS
  </h5>

  <div class="stats-filters">
    <div class="form-group">
      <label>Período:</label>
      <select class="form-control" [(ngModel)]="periodoSelecionado" (change)="atualizarPeriodoEstatisticas($event)">
        <option *ngFor="let periodo of periodos" [value]="periodo.valor">{{periodo.texto}}</option>
      </select>
    </div>

    <button class="btn btn-sm btn-outline-secondary ml-2 refresh-btn" (click)="carregueEstatisticas()" [disabled]="carregandoEstatisticas">
      <i class="fas" [ngClass]="{'fa-sync-alt': !carregandoEstatisticas, 'fa-spinner fa-spin': carregandoEstatisticas}"></i>
      Atualizar
    </button>
  </div>

  <div *ngIf="carregandoEstatisticas" class="loading-container text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando estatísticas...</span>
    </div>
    <p class="mt-2">Carregando estatísticas...</p>
  </div>

  <div *ngIf="!carregandoEstatisticas && dadosEstatisticas" class="stats-content">
    <!-- Exibir o período formatado -->
    <div class="period-display mb-3" *ngIf="dadosEstatisticas.periodo">
      <span class="period-label">{{ dadosEstatisticas.periodo.descricao }}</span>
      <span class="period-dates">{{ dadosEstatisticas.periodo.inicio }} - {{ dadosEstatisticas.periodo.fim }}</span>
    </div>

    <!-- Informação simplificada sobre cobranças da Meta -->
    <div class="meta-info-banner mb-3">
      <i class="fab fa-facebook-square mr-1"></i>
      <strong>Importante:</strong> Custos da plataforma META podem ser aplicáveis para mensagens do tipo Template enviadas fora da janela de 24h. Nossa plataforma não cobra por essas mensagens.
      <span class="info-tooltip ml-1" title="As cobranças são feitas diretamente pela Meta (Facebook/WhatsApp) na sua conta comercial do Facebook. Nossa plataforma não cobra por mensagens. Somente mensagens Template fora da janela de 24h geram custo pela Meta.">
        <i class="fas fa-info-circle"></i>
      </span>
    </div>

    <div class="row stats-cards">
      <div class="col-md-6">
        <div class="card stats-card highlight">
          <div class="card-body text-center">
            <h6 class="card-subtitle">Total de Conversas no Período</h6>
            <h2 class="card-title">{{ totalConversasPeriodo | number }}</h2>
            <small class="text-muted">
              Soma de todas as conversas registradas no período
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card stats-card cost-card">
          <div class="card-body text-center">
            <h6 class="card-subtitle d-flex align-items-center justify-content-center">
              <i class="fab fa-facebook-square meta-icon mr-1"></i>
              Custos da Plataforma META
              <span class="info-tooltip ml-1" kendoTooltip title="Custos da plataforma META podem ser aplicáveis. As cobranças são feitas diretamente pela Meta (dona do WhatsApp) na sua conta comercial do Facebook. Nossa plataforma NÃO cobra por mensagens.">
                <i class="fas fa-info-circle"></i>
              </span>
            </h6>
                  <h2 class="card-title">
        <ng-container *ngIf="custoTotalPeriodo > 0; else semCusto">
          R$ {{ custoTotalPeriodo | number:'1.2-2' }}
        </ng-container>
        <ng-template #semCusto>
          <span class="no-cost">Sem Custo META</span>
        </ng-template>
        <span class="meta-badge" title="Custos da plataforma META podem ser aplicáveis. Cobrado diretamente pela Meta na sua conta comercial do Facebook. Nossa plataforma não cobra por mensagens.">*</span>
      </h2>
      <small class="text-muted mt-1">
        * Custos da plataforma META podem ser aplicáveis
      </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Dados diários -->
    <div class="card detail-card mt-3" *ngIf="dadosEstatisticas.dataPoints && dadosEstatisticas.dataPoints.length > 0">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h6>Resumo Diário</h6>
        <span class="text-muted small">{{ dadosEstatisticas.dataPoints.length }} dias</span>
      </div>
      <div class="card-note text-muted small px-3 py-2">
        <i class="fas fa-info-circle"></i> <strong>Importante:</strong> Custos da plataforma META podem ser aplicáveis. Os valores são cobrados diretamente pela Meta na sua conta comercial do Facebook. Nossa plataforma NÃO cobra por mensagens.
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Data</th>
                <th class="text-center">Conversas</th>
                <th class="text-right">
                  Custo META
                  <i class="fas fa-info-circle info-tooltip-sm" kendoTooltip title="Custos da plataforma META podem ser aplicáveis. Valor cobrado diretamente pela Meta na sua conta comercial do Facebook. Nossa plataforma NÃO cobra por mensagens."></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ponto of dadosEstatisticas.dataPoints">
                <td>
                  <span class="data-point-day">{{ ponto.diaFormatado }}</span>
                </td>
                <td class="text-center">
                  <span class="badge" [ngClass]="{'badge-light': ponto.conversas === 0, 'badge-primary': ponto.conversas > 0}">
                    {{ ponto.conversas }}
                  </span>
                </td>
                <td class="text-right">
                  <span [ngClass]="{'text-muted': ponto.cost == 0, 'text-danger': ponto.cost > 0}">
                    {{ ponto.cost == 0 ? 'Sem Custo' : 'R$ ' + (ponto.cost | number:'1.2-2') }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="dadosEstatisticas.dataPoints.length === 0">
                <td colspan="3" class="text-center py-3">
                  <i class="fas fa-info-circle mr-2"></i> Sem dados para o período selecionado
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="facebook-link-container text-center my-4">
      <button class="btn btn-primary btn-lg" (click)="abrirEstatisticasFacebook()">
        <i class="fab fa-facebook-square mr-2"></i> Ver Estatísticas Completas no Facebook
      </button>
    </div>
  </div>

  <div *ngIf="!carregandoEstatisticas && !dadosEstatisticas" class="no-data-container">
    <div class="alert alert-info">
      <i class="fas fa-info-circle mr-2"></i> Nenhum dado disponível para o período selecionado.
    </div>
  </div>
</div>

